module.exports = __webpack_public_path__ + "images/application/logo-ac-sign-announcement-c9cce625.svg";